export const isTurnOffLTD = () => {
  // from 2025-01-17 11AM to 2025-01-21 00AM
  return Date.now() <= new Date(1737392400000).getTime();
};
